/*import Swiper from "swiper";
import {Navigation, Pagination, A11y} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";*/
import 'slick-carousel';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

(function($) {
  const initPartnersSlider = () => {
    /*const partners = document.querySelectorAll(".partners-swiper");

    partners.forEach(partner => {
      const slidesCount = partner.querySelectorAll(".swiper-slide").length;

      if (!slidesCount || slidesCount<=3) {
        return;
      }

      new Swiper(partner, {
        modules: [Navigation, Pagination, A11y],
        loop: false,
        slidesPerView: 'auto',
        loopedSlides: slidesCount,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        watchSlidesProgress: true,
        direction: 'horizontal',
        cssMode: true,
        freeMode: false,
        loopAddBlankSlides: true,
        spaceBetween: 40,
        a11y: {
          enabled: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: false,
        },
        breakpoints: {
          '768': {
            spaceBetween: 60,
          },
          '1024': {
            spaceBetween: 125,
          },
        },
      });
    });*/

    const $partners = $('.partners-slick');

    $partners.each(function(){
      const $partner = $(this);
      const slidesCount = $partner.find('.partners-slick__slide').length;

      if (!slidesCount || slidesCount<=3) {
        return;
      }

      $partner.slick({
        arrows: true,
        prevArrow: `<div class="slick-prev">
                  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.0893 4.93846C11.4147 4.61302 11.4147 4.08538 11.0893 3.75995C10.7638 3.43451 10.2362 3.43451 9.91075 3.75995L4.07742 9.59328C3.75198 9.91872 3.75198 10.4464 4.07742 10.7718L9.91075 16.6051C10.2362 16.9306 10.7638 16.9306 11.0893 16.6051C11.4147 16.2797 11.4147 15.7521 11.0893 15.4266L6.67852 11.0159L16.3333 11.0159C16.7936 11.0159 17.1667 10.6428 17.1667 10.1825C17.1667 9.7223 16.7936 9.3492 16.3333 9.3492L6.67852 9.3492L11.0893 4.93846Z" fill="#202020"/>
                  </svg>
                </div>`,
        nextArrow: `<div class="slick-next">
                  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.91075 3.75995C10.2362 3.43451 10.7638 3.43451 11.0893 3.75995L16.9226 9.59328C17.248 9.91872 17.248 10.4464 16.9226 10.7718L11.0893 16.6051C10.7638 16.9306 10.2362 16.9306 9.91075 16.6051C9.58532 16.2797 9.58532 15.7521 9.91075 15.4266L14.3215 11.0159H4.66668C4.20644 11.0159 3.83334 10.6428 3.83334 10.1825C3.83334 9.7223 4.20644 9.3492 4.66668 9.3492H14.3215L9.91075 4.93846C9.58532 4.61302 9.58532 4.08538 9.91075 3.75995Z" fill="#202020"/>
                  </svg>
                </div>`,
        dots: true,
        variableWidth: true,
        mobileFirst: true,
      });
    });
  };

  document.addEventListener("DOMContentLoaded", function() {
    initPartnersSlider();
  });

  /*window.addEventListener('load', () => {
    initPartnersSlider();
  });*/
})(jQuery);
